<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} ContactRole` }}
            </h4>
            <v-form ref="contactRoleForm" @submit.prevent="save()">
              <v-row>
                <v-col md="12">
                  <v-text-field
                    v-model="contactRoleModel.name"
                    label="ContactRole Name"
                    required
                    outlined
                    :rules="[(v) => !!v || 'ContactRole Name is required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { ContactRole } from "@/models/ContactRole";
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      contactRoleModel: new ContactRole(),
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "ContactRoles",
          disabled: false,
          href: "/admin/contactRoles",
        },
        {
          text: "ContactRole Detail",
          disabled: false,
          href: `/admin/contactRoles/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} ContactRole`,
          disabled: true,
        },
      ];
    },
  },
  watch: {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    contactRole: {
      query: gql`
        query ContactRole($id: ID!) {
          contactRole(id: $id) {
            id
            name
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.contactRoleModel.id = this.contactRole.id;
        this.contactRoleModel.name = this.contactRole.name;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.contactRoleForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateContactRole()
          .then(() => {
            this.$swal("Success!", "ContactRole was updated", "success");
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "something went wrong when trying to update the contactRole, check data and try again later!",
              "error"
            );
          });
      } else {
        // create
        await this.createContactRole()
          .then(() => {
            this.$swal("Success!", "ContactRole was created", "success");
            window.location.href = `/admin/contactRoles/${self.contactRoleModel.id}/edit`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `Something went wrong when creating the contactRole, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateContactRole() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($contactRole: ContactRoleUpdateInput!) {
              updateContactRole(contactRole: $contactRole) {
                id
                updated
              }
            }
          `,
          variables: {
            contactRole: {
              id: self.contactRoleModel.id,
              name: self.contactRoleModel.name,
              createdBy: self.me.id,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the contactRole!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createContactRole() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createContactRole($contactRole: ContactRoleCreateInput!) {
              createContactRole(contactRole: $contactRole) {
                id
              }
            }
          `,
          variables: {
            contactRole: {
              name: self.contactRoleModel.name,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the ContactRole Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createContactRole) {
          self.contactRoleModel.id = response?.data?.createContactRole?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
